import type { FooterCTACategory } from '../validateFooter'

export const getFeaturedLinkCategory = (title: string): FooterCTACategory => {
  const normalizedTitle = title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

  return normalizedTitle.includes('app') ? 'Baixe o app' : 'Seja membro'
}
